export const TEMPLATE_TYPE = Object.freeze({
  WORKKARD: "Workkard",
  ACTIVITY: "Activity",
  CONTACT: "Contact",
});
